module.exports = __webpack_public_path__ + "img/pro_two_1.e5f795fd.jpg";